"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _getWidgetStyle = require("@insided/deprecated-preact-components/utils/getWidgetStyle");

var _zod = require("zod");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widgetName = 'banner';
exports.widgetName = widgetName;

var positionConfig = _zod.z.enum(['Top', 'Bottom', 'Left', 'Right']);

var textAlignmentConfig = _zod.z.enum(['Left', 'Center', 'Right']);

var cssAnchorName = 'widget-banner';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  content: _zod.z.object({
    textAlignment: textAlignmentConfig,
    title: _zod.z.string(),
    description: _zod.z.string()
  }),
  buttons: _zod.z.object({
    primaryText: _zod.z.string(),
    primaryUrl: _zod.z.string(),
    secondaryText: _zod.z.string().optional(),
    secondaryUrl: _zod.z.string().optional()
  }).optional(),
  image: _zod.z.object({
    src: _zod.z.string(),
    position: positionConfig,
    description: _zod.z.string().optional()
  }).optional()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

function flexDirection(position) {
  switch (position) {
    case 'Top':
      return 'column';

    case 'Bottom':
      return 'column-reverse';

    case 'Left':
      return 'row';

    case 'Right':
      return 'row-reverse';
  }
}

var Banner = function Banner(props) {
  var _image$position;

  var content = props.content,
      buttons = props.buttons,
      image = props.image,
      backgroundColor = props.backgroundColor,
      backgroundColorDisplay = props.backgroundColorDisplay,
      descriptionColor = props.descriptionColor,
      descriptionColorDisplay = props.descriptionColorDisplay,
      hideSpacingWithUpperWidget = props.hideSpacingWithUpperWidget,
      paddingToTopAndBottom = props.paddingToTopAndBottom,
      titleColor = props.titleColor,
      titleColorDisplay = props.titleColorDisplay,
      subtitleColor = props.subtitleColor,
      subtitleColorDisplay = props.subtitleColorDisplay;
  var isPrimaryButton = buttons && Boolean(buttons.primaryUrl) && Boolean(buttons.primaryText);
  var isSecondaryButton = buttons && Boolean(buttons.secondaryUrl) && Boolean(buttons.primaryText);
  var textAlignment = content.textAlignment.toLowerCase();
  var titleColorStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: titleColor,
    colorDisplay: titleColorDisplay
  });
  var descriptionColorStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: descriptionColor,
    colorDisplay: descriptionColorDisplay
  });
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: "banner",
    config: {
      // we do not pass title/subtitle to the container
      // TODO: Introduce parameter noTitle and noSubtitle to be able to pass the whole config
      // or another, more sustainable approach
      backgroundColor: backgroundColor,
      backgroundColorDisplay: backgroundColorDisplay,
      hideSpacingWithUpperWidget: hideSpacingWithUpperWidget,
      paddingToTopAndBottom: paddingToTopAndBottom,
      titleColor: titleColor,
      titleColorDisplay: titleColorDisplay,
      subtitleColor: subtitleColor,
      subtitleColorDisplay: subtitleColorDisplay
    }
  }, (0, _preact.h)("div", {
    className: "qa-banner-container banner-container"
  }, (0, _preact.h)("div", {
    className: "sitewidth banner-widget__layout",
    style: {
      flexDirection: flexDirection((_image$position = image === null || image === void 0 ? void 0 : image.position) !== null && _image$position !== void 0 ? _image$position : 'Top')
    }
  }, Boolean(image === null || image === void 0 ? void 0 : image.src) && (0, _preact.h)("div", {
    className: "banner-widget__image",
    style: {
      paddingBottom: (image === null || image === void 0 ? void 0 : image.position) === 'Top' ? '24px' : 0
    }
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(image === null || image === void 0 ? void 0 : image.src),
    alt: image === null || image === void 0 ? void 0 : image.description,
    role: // Always use proper accessibility behavior
    image !== null && image !== void 0 && image.description ? 'img' : 'presentation'
  })), (0, _preact.h)("div", {
    className: "banner-widget__contents",
    style: {
      paddingBottom: (image === null || image === void 0 ? void 0 : image.position) === 'Bottom' ? '24px' : 0
    }
  }, (0, _preact.h)("div", {
    className: "text-".concat(textAlignment)
  }, Boolean(content.title) && (0, _preact.h)("h2", {
    style: titleColorStyle,
    className: "widget__heading"
  }, content.title), Boolean(content.description) && (0, _preact.h)("div", {
    style: descriptionColorStyle,
    dangerouslySetInnerHTML: {
      __html: content.description
    }
  })), (isPrimaryButton !== null && isPrimaryButton !== void 0 ? isPrimaryButton : isSecondaryButton) && (0, _preact.h)("div", {
    className: "text-".concat(textAlignment, " banner-widget__button")
  }, isPrimaryButton && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(buttons.primaryUrl),
    className: "btn--cta"
  }, buttons.primaryText), isSecondaryButton && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(buttons.secondaryUrl),
    className: "btn--secondary"
  }, buttons.secondaryText))))));
};

var _default = Banner;
exports.default = _default;